import type { UpdateStudentConsecutiveCorrectAnswer } from 'actions/sheet-correct-answer-count';
import type { Reducer } from 'redux';

import { ACTIONS } from 'actions/sheet-correct-answer-count';

interface initState {
  consecutiveCount: number;
}

const initialState: initState = {
  consecutiveCount: 0,
};

type TReducer = Reducer<initState, ReturnType<UpdateStudentConsecutiveCorrectAnswer>>;

const consecutiveCountReducer: TReducer = (state = initialState, { type, payload }) => {
  if (type === ACTIONS.UPDATE_STUDENT_CONSECUTIVE_CORRECT_ANSWER) {
    return {
      ...state,
      ...payload,
    };
  }

  if (type === ACTIONS.CLEAR_STUDENT_CONSECUTIVE_CORRECT_ANSWER) {
    return {
      ...state,
      consecutiveCount: 0,
    };
  }

  return state;
};

export default consecutiveCountReducer;
